import React, { Component } from 'react';
import axios from "axios";
import { connect } from 'react-redux';
import { Line, Gap, ProgressBar, LabelTitle, LabelLevel, FooterReport } from "../../../../components/Global";
import { cekCookies } from '../../../../actions';
import __ from 'lodash';
import LoaderModal from "../../../../components/modal/LoaderModal";
import utilManagement from "../../../../apis/utilManagement";
import jsonFile from "./report_ensa_siswa.json"
import { CONFIG_UTIL } from "../../../../config";
import {
    ReportHeader,
    CardProfile,
    EnsaCard,
    EnsaCard2,
} from "../index";
import { ChartBubleLainKelas, ChartBubleLainSekolah } from '../../../../components/Global';

class ReportSiswa extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            dataStudent: {},
            dataPerformaLiterasi: [],
            surveiKarakter: [],
            dataPerformaKelas: [],
            dataPerformaSekolah: [],
        }
    }

    async componentDidMount() {
        this.setState({
            isFetching: true
        });
        this.getReport()
    }

    async getReport() {
        const id = this.props.history.location.pathname.split("/");
        const res = await utilManagement.post(CONFIG_UTIL.REPORT_ENSA_SISWA, {
            "idJadwalCbt": id[2],
            "idSiswa": id[3],
            "idSekolah": id[4],
            "idKelas": id[5],
            "idKelasParalel": id[6],
            "tahunAjaran": id[7].concat('/').concat(id[8])
        })
        // .catch(function (error) { console.log('ERROR', error); });
        // const res = jsonFile.data
        if (res.data) {
            const response = res.data.data;
            console.log('response data ======= ', response.dataSiswa)
            this.setState({
                isFetching: false,
                dataStudent: response.dataSiswa,
                dataPerformaLiterasi: response.performaLiterasi,
                surveiKarakter: response.surveiKarakter,
                dataPerformaKelas: response.posisiPerformaKelas,
                dataPerformaSekolah: response.posisiPerformaSekolah,
            })
        }
    }

    render() {
        require("./ReportSiswa.css");
        const { isFetching, dataStudent, dataPerformaLiterasi, surveiKarakter, dataPerformaKelas, dataPerformaSekolah } = this.state;
        return (
            <div>
                <LoaderModal isFetching={isFetching} />
                {/* page 1 */}
                <div className="report-page">
                    <div className="card-header">
                        <div className="flex-header">
                            <div style={{ width: '70%' }}>
                                <div className="title-header2">EDUPRIME FOR NATIONAL STUDENT ASSESSMENT</div>
                                <div className="label-subTit">Rapor Pendidikan Siswa</div>
                            </div>
                            <div className="pnl-right-header">
                                <img src="/assets/image/logo_eduprime.png" width={"150px"} />
                            </div>
                        </div>
                    </div>
                    <div className="cardLine">
                        <div className="flex-pln-profile">
                            <CardProfile
                                label={"Nama Siswa"}
                                value={dataStudent.namaSiswa}
                                iconImage={"/assets/image/mdi_person.svg"}
                            />
                            <CardProfile
                                label={"Sekolah"}
                                value={dataStudent.namaSekolah}
                                iconImage={"/assets/image/icon-sekolah.svg"}
                            />
                            <CardProfile
                                label={"Kelas"}
                                value={dataStudent.namaKelasParalel}
                                iconImage={"/assets/image/icon-kelas.svg"}
                            />
                            <CardProfile
                                label={"Tgl Asesmen"}
                                value={dataStudent.jadwalMulai}
                                iconImage={"/assets/image/mdi_date.svg"}
                            />
                        </div>

                        <div className="point-title">A. Performa Literasi</div>
                        <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                            {dataPerformaLiterasi.map((literasi, i) => {
                                return (
                                    <div className="card-profile" style={{ width: '50%' }}>
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div className="point-title" style={{ fontSize: '14px', marginBottom: '0' }}>{literasi.namaMapel}</div>
                                            <div className="label-kategori" style={{ backgroundColor: literasi.kategori == 'DASAR' ? '#F97316' : literasi.kategori == 'CAKAP' ? '#03C46B' : '#FF3838' }}>{literasi.kategori}</div>
                                        </div>

                                        <div style={{ width: '100%' }}>
                                            {literasi.listData.map((item, i) => {
                                                return (
                                                    <div key={i} style={{ marginBottom: '20px' }}>
                                                        <ProgressBar
                                                            level={"Level " + item.level}
                                                            ratio={item.skor + "/" + item.range}
                                                            progressValue={(item.skor / Math.round(item.range)).toFixed(2) * 100}
                                                            progressColor={item.level == 1 ? "#FF3838" : item.level == 2 ? "#03C46B" : "#0097CE"}
                                                            heightBar={23}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="point-title">B. Posisi performa terhadap siswa lain</div>
                        <div className="flex-pnl-between" style={{ gap: '20px' }}>
                            <EnsaCard2 title="Posisi performa terhadap siswa lain-Kelas" width={50}>
                                <ChartBubleLainKelas data={dataPerformaKelas} />
                            </EnsaCard2>
                            <EnsaCard2 title="Posisi performa terhadap siswa lain-Sekolah" width={50}>
                                <ChartBubleLainKelas data={dataPerformaSekolah} />
                            </EnsaCard2>
                        </div>

                    </div>


                </div>

                {/* page 2 */}
                <div className="report-page-last">
                    <div className="card-header">
                        <div className="flex-header">
                            <div style={{ width: '70%' }}>
                                <div className="title-header2">EDUPRIME FOR NATIONAL STUDENT ASSESSMENT</div>
                                <div className="label-subTit">Rapor Pendidikan Siswa</div>
                            </div>
                            <div className="pnl-right-header">
                                <img src="/assets/image/logo_eduprime.png" width={"150px"} />
                            </div>
                        </div>
                    </div>
                    <div className="cardLine">
                        <div className="point-title" style={{ margin: ' 20px 0 0 0' }}>C. Survei Karakter</div>
                        <div className="card-profile" style={{ marginTop: '20px', padding: '0px' }}>
                            <div style={{ width: '100%' }}>
                                {surveiKarakter.map((dataSK, i) => {
                                    return (
                                        <div key={i}>
                                            <div className="card-sk">
                                                <div className="section-four-left" style={{ width: '5%', display: 'flex', alignItems: 'center' }}>
                                                    <div>
                                                        <img
                                                            src={
                                                                dataSK.nama == "KREATIF"
                                                                    ? "/assets/image/mdi_lightbulb.svg"
                                                                    : dataSK.nama === "COOP"
                                                                        ? "/assets/image/mdi_people.svg"
                                                                        : dataSK.nama == "KRITIS"
                                                                            ? "/assets/image/mdi_hub.svg"
                                                                            : dataSK.nama == "MANDIRI"
                                                                                ? "/assets/image/mdi_mandiri.svg"
                                                                                : dataSK.nama == "BHINEKA"
                                                                                    ? "/assets/image/mdi_religion-islamic.svg"
                                                                                    : "/assets/image/mdi_earth.svg"
                                                            }
                                                            width={"50px"}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="section-four-center" style={{ width: '90%' }}>
                                                    <div>
                                                        <div style={{ display: 'flex', gap: '20px' }}>
                                                            <LabelTitle size={16} bolder={500} color={"#212529"} label={dataSK.judul} />
                                                            <LabelLevel
                                                                color={'#FFF'}
                                                                bgColor={dataSK.kategori == 'Membudaya'.toUpperCase() ? '#03C46B' : dataSK.kategori == 'Berkembang'.toUpperCase() ? '#F97316' : '#FF3838'}
                                                                level={dataSK.kategori} style={{ with: '100%' }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <LabelTitle size={16} bolder={200} color={"#6C757D"} label={dataSK.deskripsi} />
                                                </div>
                                                <div style={{width: '6%', textAlign: 'center'}}>
                                                    <div style={{ fontSize: '18px', color: '#757575' }}>Skor</div>
                                                    <div className='value-skor'>{dataSK.skor}</div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                {/* End :: Page Two */}
                <div className="fixedButton">
                    <button className="buttonPrint" onClick={() => {
                        document.title = dataStudent.namaSiswa;
                        window.print();
                        document.title = 'EduPrime';
                    }}>
                        <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                        Print Report
                    </button>
                </div>
            </div >

        )

    }

};
export default ReportSiswa;